<span class="theme-preview-row" [class.theme-preview-row--compact]="compact">
  <span class="theme-preview" [style.background-color]="primary"></span>
  <span class="theme-preview" [style.background-color]="secondary"></span>
  <span class="theme-name">{{ displayName }}</span>
  @if (showModeLabel && modeLabel) {
    <span class="theme-mode">{{ modeLabel }}</span>
  }
</span>
